module.exports = "<div fxLayout=\"column\" class=\"container-modal\">\r\n  <div fxLayout fxLayoutAlign=\"end\">\r\n    <button mat-icon-button (click)=\"closeModal()\">\r\n      <mat-icon>close</mat-icon>\r\n    </button>\r\n  </div>\r\n  <ng-container *ngIf='safeUrlVisor'>\r\n  <iframe [src]=\"safeUrlVisor\" width=\"650px\" height=\"650px\" sandbox=\"allow-scripts allow-same-origin\"\r\n    class=\"container-visor\"></iframe>\r\n  </ng-container>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/devoluciones/devoluciones.component.html
// module id = ../../../../../src/app/components/devoluciones/devoluciones.component.html
// module chunks = main